import React from 'react';

const _SettingNotification = () => {
    return (
        <div>

        </div>
    );
};

export default _SettingNotification;
